import React from "react";
import TextField from "../../../bootstrap/TextField";
import {
  FirstNameAndNid,
  Passenger,
  Select,
  UserContactWrapper,
} from "./singleTravellerInformation.styles";

const SingleTravellerInformation = ({
  values,
  passengerIndex,
  handleChange,
  roundTrip,
}) => {
  return (
    <>
      <Passenger>
        {roundTrip ? (
          <label htmlFor={`rname${passengerIndex ? passengerIndex : ""}`}>
            Passager {passengerIndex}
          </label>
        ) : (
          <label htmlFor={`name${passengerIndex ? passengerIndex : ""}`}>
            Passager {passengerIndex}
          </label>
        )}

        {roundTrip ? (
          <UserContactWrapper>
            <FirstNameAndNid>
              <Select
                name={`gender${passengerIndex ? passengerIndex : ""}`}
                id={`gender${passengerIndex ? passengerIndex : ""}`}
                onChange={handleChange}
              >
                <option value="Mr">Mr</option>
                <option value="Ms">Ms</option>
              </Select>
              <TextField
                id={`first${passengerIndex}`}
                name={`first${passengerIndex}`}
                type="text"
                placeholder="Prénom"
                value={values[`first${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </FirstNameAndNid>
            <TextField
              type="text"
              placeholder="Nom"
              name={`rsurName${passengerIndex}`}
              value={values[`rsurName${passengerIndex}`]}
              onChange={handleChange}
              autoComplete="nope"
            />
          </UserContactWrapper>
        ) : (
          <UserContactWrapper>
            <FirstNameAndNid>
              <Select
                name={`gender${passengerIndex ? passengerIndex : ""}`}
                id={`gender${passengerIndex ? passengerIndex : ""}`}
                onChange={handleChange}
              >
                <option value="Mr">Mr</option>
                <option value="Ms">Ms</option>
              </Select>
              <TextField
                id={`first${passengerIndex}`}
                name={`first${passengerIndex}`}
                type="text"
                placeholder="Prénom"
                value={values[`first${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </FirstNameAndNid>
            <TextField
              type="text"
              placeholder="Nom"
              name={`second${passengerIndex}`}
              value={values[`second${passengerIndex}`]}
              onChange={handleChange}
              autoComplete="nope"
            />
          </UserContactWrapper>
        )}
      </Passenger>
      {/* end passenger */}

      {roundTrip ? (
        <Passenger>
          <label htmlFor={`rnid${passengerIndex ? passengerIndex : ""}`}>
            CNI / Passeport
          </label>
          <UserContactWrapper>
            {/* start */}
            <FirstNameAndNid>
              <TextField
                id={`rnid${passengerIndex ? passengerIndex : ""}`}
                name={`renid${passengerIndex}`}
                type="text"
                placeholder="Numéro de document"
                value={values[`renid${passengerIndex}`]}
                onChange={handleChange}
              />
            </FirstNameAndNid>

            <TextField
              type="number"
              placeholder="Numéro de contact"
              name={`contactNo${passengerIndex}`}
              value={values[`contactNo${passengerIndex}`]}
              onChange={handleChange}
              autoComplete="nope"
            />
          </UserContactWrapper>
        </Passenger>
      ) : (
        <Passenger>
          <label htmlFor={`nid${passengerIndex ? passengerIndex : ""}`}>
            CNI / Passeport
          </label>
          <UserContactWrapper>
            {/* start */}
            <FirstNameAndNid>
              <TextField
                id={`nid${passengerIndex ? passengerIndex : ""}`}
                name={`renid${passengerIndex}`}
                type="text"
                placeholder="Numéro de document"
                value={values[`renid${passengerIndex}`]}
                onChange={handleChange}
              />
            </FirstNameAndNid>

            <TextField
              type="number"
              placeholder="Numéro de contact"
              name={`contactNo${passengerIndex}`}
              value={values[`contactNo${passengerIndex}`]}
              onChange={handleChange}
              autoComplete="nope"
            />
          </UserContactWrapper>
        </Passenger>
      )}
    </>
  );
};

export default SingleTravellerInformation;
